import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import './Disclaimer.css';

const Disclaimer = () => {
    const [isVisible, setIsVisible] = useState(false);
  
    useEffect(() => {
      const hasAcceptedDisclaimer = Cookies.get("disclaimerAccepted");
  
      if (!hasAcceptedDisclaimer) {
        setIsVisible(true); // Show the disclaimer if not accepted
      }
    }, []);
  
    const handleAccept = () => {
      setIsVisible(false); // Hide the disclaimer
   //   Cookies.set("disclaimerAccepted", "true", { expires: 1 }); // Set the cookie for 1 year
    };
  
    return (
      <>
        {isVisible && (
          <div className="disclaimer">
            <div className="disclaimer-content">
              <h4>Disclaimer</h4>
<h5>As per the rules of the Bar Council of India, we are not permitted to solicit work and advertise. The user acknowledges the following:</h5>
 <div className="disclaimer-points">
                  <p>There has been no advertisement, personal communication, solicitation, invitation or inducement of any sort whatsoever from us or any of our members to solicit any work through this website.</p>
                  <p>The user wishes to gain more information about us for his/her own information and use.</p>
                  <p>The information about us is provided to the user only on his/her specific request and any information obtained or materials downloaded from this website is completely at the user’s volition and any transmission, receipt or use of this site would not create any lawyer-client relationship.</p>
                  <p>The information provided under this website is solely available at your request for informational purposes only, should not be interpreted as soliciting or advisement. We are not liable for any consequence of any action taken by the user relying on material/information provided under this website. In cases where the user has any legal issues, he/she in all cases must seek independent legal advice.</p>
                  <p>The information provided on the site is of a general nature regarding the law. The readers are advised not to act upon this general information. Please take further and appropriate advice based on the facts of your case from The Indian Lawyer by logging a query.</p>
                  <p>The Indian Lawyer disclaims its liability for any adverse acts taken by the readers based on the general information provided by the site.</p>
    
                </div>

              <button onClick={handleAccept}>Accept</button>
            </div>
          </div>
        )}
      </>
    );
  };
  
  export default Disclaimer;